import { combineWhereClauses } from 'v2/core/services/queryBuilder/combineWhereClauses';
import {
  OperationType,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';

interface GetWhereClauseForMetadataFieldMappingParams {
  sourceField: string;
  targetField: string;
}

export const getWhereClauseForMetadataFieldMapping = ({
  sourceField,
  targetField,
}: GetWhereClauseForMetadataFieldMappingParams) => {
  const sourceFieldWhereClause: WhereClause = {
    filter: {
      hasMetadataFilter: {
        keys: [sourceField],
      },
    },
  };

  const targetFieldWhereClause: WhereClause = {
    filter: {
      hasMetadataFilter: {
        keys: [targetField],
      },
    },
  };

  return combineWhereClauses(
    sourceFieldWhereClause,
    targetFieldWhereClause,
    OperationType.AND,
  );
};
